export const createApiHeadersGetter = (getAuthToken: () => Promise<string | null>) => {
  return async (): Promise<HeadersInit> => {
    const token = await getAuthToken();
    return {
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': `Bearer ${token}` } : {})
    };
  };
};